/**
 *
 * EditPassword
 *
 */

import { connect, ConnectedProps } from "react-redux";
import { compose } from "redux";
import { injectReducer, injectSaga, SagaInjectionModes } from "redux-injectors";

import { UserInfo } from "types/UserInfo";
import withAuth from "utils/withAuth";
import Layout from "./layout";
import selectEditPasswordDataProps from "./selectors";

import reducer, { actionProps } from "./redux";
import saga from "./saga";

const mapStateToProps = selectEditPasswordDataProps;
const mapDispatchToProps = actionProps;

const withConnect = connect<
  ReturnType<typeof mapStateToProps>,
  ReturnType<typeof mapDispatchToProps>,
  {} // own props type
>(mapStateToProps, mapDispatchToProps);
const withReducer = injectReducer({
  key: "dashboardEditPassword",
  reducer,
});
const withSaga = injectSaga({
  key: "dashboardEditPassword",
  saga,
  mode: SagaInjectionModes.RESTART_ON_REMOUNT,
});

export default compose(
  withConnect,
  withReducer,
  withSaga,
  withAuth({ route: "/dashboard/securitysettings/edit-password" })
)(
  Layout as React.ComponentType<
    ConnectedProps<typeof withConnect & { userInfo: UserInfo }>
  >
);
